import React, { useEffect, useState, useRef } from "react";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";
import BannerImage from "../components/img/ophthalmology-banner.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import axios from 'axios';
import "../styles/pages.css";
import { FaChevronRight, FaCircleArrowRight } from "react-icons/fa6";
import { useNavigate } from 'react-router-dom';

function Ophthalmology() {
  const [activeSection, setActiveSection] = useState("overview");
  const [isFixed, setIsFixed] = useState(false);
  const sectionsRef = {
    overview: useRef(null),
    treatment: useRef(null),
    facilities: useRef(null),
    doctors: useRef(null),
  };
  const sidebarRef = useRef(null);
  const contentRef = useRef(null);
  const footerRef = useRef(null);

  const handleScroll = () => {
    const sections = ["overview", "treatment", "facilities", "doctors"];
    let currentSection = "";
    let setFix = false;
    for (let section of sections) {
      const ref = sectionsRef[section].current;
      const { top, bottom } = ref.getBoundingClientRect();
      const isInView =
        top <= window.innerHeight / 2 && bottom >= window.innerHeight / 2;
      if (top < 85) {
        setFix = true;
      } else {
        setFix = false;
      }
      if (isInView) {
        console.log("top", top, "bottom", bottom, "win", window.innerHeight);
        currentSection = section;
      }
    }
    setIsFixed(setFix);
    setActiveSection(currentSection);
  };

  // const scrollToSection = (section) => {
  //   sectionsRef[section].current.scrollIntoView({ behavior: "smooth",block:"center" });
  // };

  const scrollToSection = (section) => {
    const sectionElement = sectionsRef[section].current;
    if (sectionElement) {
      const offsetTop = sectionElement.getBoundingClientRect().top + window.scrollY;
      const headerOffset = 100; // Adjust this value to match the height of your fixed header or sidebar
      window.scrollTo({
        top: offsetTop - headerOffset,
        behavior: "smooth",
      });
    }
  };


  useEffect(() => {
    handleScroll(); // Trigger once on load
    window.addEventListener("scroll", handleScroll);
  }, []);

  const [doctors, setDoctors] = useState([]);

  useEffect(() => {
    const fetchDoctors = async () => {
      try {
        const response = await axios.get(`https://caritasmathahospital.com/wp-content/themes/my_react_theme/api/get_doctors.php?department=Ophthalmology`);
        setDoctors(response.data);
      } catch (error) {
        console.error("Error fetching doctors:", error);
      }
    };
    fetchDoctors();
  }, []);
  

  const navigate = useNavigate();

  const handleDoctorClick = (doctor) => {
    navigate(`/doctor/${doctor.id}`, { state: { doctor } })
  };

  return (
    <div>

      <Navbar />

      <section className="page-section">
          <div className="section-content">
              <p className='page-heading'>Ophthalmology Department </p>

              <p className="page-subtitle">
                Comprehensive Eye Care for Vision Health and Clarity
              </p>

              
              <div className="page-box">
                  <div className="box-content">
                      <p>Caritas Matha Hospital Ophthalmology Department aims to deliver a comprehensive medical and surgical service delivery on eye disorders. Our ophthalmologist doctors possess extensive experience in analyzing various diseases about vision that reflect on the overall health of the eyes.</p>
                  </div>
                  <div className="box-image">
                      <img src={BannerImage} alt="Ophthalmology Banner"/>
                  </div>
              </div>
          </div>
      </section>
      <section className="dept-section">
        <div
          ref={sidebarRef}
          className={`sidebar-title ${!isFixed ? "fixed" : ""}`}
        >
          {["overview", "treatment", "facilities", "doctors"].map((section) => (
            <p
              key={section}
              className={`title ${activeSection === section ? "active" : ""}`}
              onClick={() => scrollToSection(section)}
            >
              {section.charAt(0).toUpperCase() + section.slice(1)}
              {activeSection === section && (
                <FontAwesomeIcon
                  icon={faChevronRight}
                  className="chevron-icon"
                />
              )}
            </p>
          ))}
        </div>
        <div ref={contentRef} className="contents">
          <div ref={sectionsRef.overview} className="overview-content">
            <p className="content-heading">Overview</p>
            {/* Overview content here */}
            <p>The Caritas Matha Hospital is one of the best ophthalmology centers, providing all the medical and surgical solutions for eye diseases. This is through employing professional caregivers whose skills are enabled to adequately meet individual client needs for the best results to be achieved</p>
            <p>Eye care services, including surgery for sight impairments, are easily provided in our department due to the advanced technology available in diagnosing eye conditions. Chief among these are precision, safety, and the overall welfare of the patient regardless of the procedures and conditions we are handling, such as sight restoration and chronic disease management.</p>
            <p>The patient-centric approach is one of Caritas Matha Hospital's priorities, encompassing patient care before, during, and after treatment. We have modern equipment and highly qualified personnel dedicated to a commitment to excellence in providing eye health services.</p>
          </div>
          <div ref={sectionsRef.treatment} className="treatment-content">
            <p className="content-heading">Treatment</p>
            {/* Treatment content here */}

            <ul>
              <li><span className="subtitle">Cataract Surgery: </span>Modern surgical techniques for the elimination of cataracts and the granting of vision.</li>
              <br/>

              <li><span className="subtitle">Lasik and Refractive Surgery: </span>Glasses and contact lens removal to improve human eyesight.</li>
              <br/>

              <li><span className="subtitle">Glaucoma management: </span>Complete solutions for the diagnosis, evaluation, and treatment of the disorder.</li>
              <br/>

              <li><span className="subtitle">Retinal Treatments: </span>Specialized interventions for retinal diseases such as diabetic retinopathy and macular degeneration.</li>
              <br/>

              <li><span className="subtitle">Pediatric Ophthalmology: </span>Assessment, diagnosis, and management of children’s eye ailments such as squint and lazy eye.</li>
              <br/>

              <li><span className="subtitle">Oculoplastic Surgery: </span>Repair and aesthetic surgery of eyelids, tear ducts, and other adjoining structures.</li>
              <br/>

              <li><span className="subtitle">Neuro-Ophthalmology: </span>Dealing with the diagnosis and treatment of vision problems arising from neurological diseases.</li>
              <br/>

              <li><span className="subtitle">Uveitis and Ocular Inflammation Treatment: </span>Targeted therapies for inflammatory eye diseases.</li>
              <br/>

              <li><span className="subtitle">Diabetic Eye Care: </span>Preventing and Treating Ocular Complications in Diabetic Patients.</li>
              <br/>

              <li><span className="subtitle">Dry Eye and Allergy Management: </span>Customized treatments for chronic dryness, irritation, and allergic reactions.</li>
              <br/>

              <li><span className="subtitle">Keratoconus Treatment: </span>Specialized procedures for corneal thinning and vision stabilization.</li>
              <br/>

              <li><span className="subtitle">Comprehensive Eye Checkups: </span>Routine screenings and diagnostic evaluations for eye health.</li>
              <br/>
            </ul>
          </div>
          <div ref={sectionsRef.facilities} className="facilities-content">
            <p className="content-heading">Facilities</p>
            {/* Facilities content here */}
            <ul>
              <li>Advanced diagnostic imaging systems for precise evaluation</li>
              <br/>

              <li>Technologically sophisticated operating theaters are suitable for conducting eye surgeries.</li>
              <br/>

              <li>Comprehensive vision testing and refraction services</li>
              <br/>

              <li>Dedicated units for pediatric and geriatric eye care</li>
              <br/>

              <li>Specialized laser technology for vision correction and retinal treatments</li>
              <br/>

              <li>Integrated care approach with other medical specialties for holistic treatment</li>
              <br/>

              <li>Strict infection control and hygiene protocols for patient safety</li>
              <br/>
            </ul>

            <p>Welcome to the Ophthalmology Department of Caritas Matha Hospital, where eye health is of utmost importance to us, and we ensure we deliver the best care with advanced equipment.</p>
          </div>

          <div ref={sectionsRef.doctors} className="doctors">
              <p className="content-heading">Doctors</p>
              {doctors.length > 0 ? (
                <div className='doctorbox-container'>
                    {doctors.map(doctor => (
                      <div key={doctor.id} className="doctorbox">
                          <div className="doctor-box">
                              <img src={doctor.image_url} className='doctor-img' onClick={() => handleDoctorClick(doctor)} style={{ cursor: "pointer" }}/>
                              <div className='doctor-details'>
                                  <h4 onClick={() => handleDoctorClick(doctor)} style={{ cursor: "pointer" }}>{doctor['name']}</h4>
                                  <p>{doctor['designation']}</p>
                                  <p>{ doctor.available_time }</p>
                                  <br/>
                                  {parseInt(doctor.appointment_enabled) === 1 && (
                                      <p>
                                          <a href="https://booking.caritasmathahospital.com/OnlineAppointmentBooking/OnlineAppointmentBooking.aspx" target="_blank" rel="noopener noreferrer" >
                                              Book An Appointment <FaChevronRight />
                                          </a>
                                      </p>
                                  )}
                              </div>
                          </div>
                          <div className='arrow-section'>
                              <FaCircleArrowRight className='right-circle-arrow' onClick={() => handleDoctorClick(doctor)} style={{ cursor: "pointer" }}/>
                          </div>
                      </div>
                    ))}
                </div>
              ) : (
                  <p>No doctors available in this department.</p>
              )}
          </div>
        </div>
      </section>
      <Footer ref={footerRef} />
    </div>
  );
}

export default Ophthalmology;